import { useParams } from "react-router-dom";
import { Activity, Settings } from "lucide-react";
import { NAV } from "@/components/Shell";

export default function ModulePage() {
  const { slug } = useParams();
  const item = NAV.find((n) => n.to === `/modules/${slug}`);
  const Icon = item?.icon || Settings;
  return (
    <div className="content empty-page" data-testid={`module-page-${slug}`}>
      <div className="empty-illustration"><Icon size={32} /></div>
      <p className="eyebrow">{(item?.label || slug).toUpperCase()}</p>
      <h1>Coming in the <em>next phase.</em></h1>
      <p className="muted">This module will share the same patient register and ledger. Voice entries mentioning it are kept with their dictation until then.</p>
      <div className="coming-note"><Activity size={17} /> Not available yet</div>
    </div>
  );
}

export function PendingAccess({ member, onSignOut }) {
  return (
    <main className="login-shell single">
      <section className="login-panel">
        <div className="login-form" data-testid="pending-access">
          <p className="eyebrow">ACCESS PENDING</p>
          <h2>Welcome, {member.name || member.email}.</h2>
          <p className="muted">Your account is created. A clinic administrator needs to assign your role before you can see patient records.</p>
          <button className="primary full" onClick={onSignOut} data-testid="pending-sign-out-button">Sign out</button>
        </div>
      </section>
    </main>
  );
}
